import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faQuoteLeft } from '@fortawesome/free-solid-svg-icons';
import { faDiscord } from '@fortawesome/free-brands-svg-icons';
import Avatar from '../common/Avatar';
import Username from '../common/Username';

const StepInfo = props => {
    if (props.application) {
        switch(props.application.state) {
            case "step_1_submitted":
            case "step_1_redo_submitted":
            case "step_2_submitted":
            case "step_2_redo_submitted":
                return (
                    <div className="panel-adt">
                        <h2>Officer Review</h2>
                        <div className="adt-flex-container" style={{alignItems: "flex-start"}}>
                            <div className="adt-flex-icon">
                                <FontAwesomeIcon className="text-primary" size="lg" icon={faInfoCircle} fixedWidth />
                            </div>
                            <div className="adt-flex-item">
                                <p style={{margin:0}}>Your application is currently undergoing review by a Recruitment Officer.  You will be contacted shortly via email once your application has been assessed and a decision has been made.  Please be sure you do not miss this notification email because of a spam filter.</p>
                            </div>
                        </div>
                    </div>
                );
            case "step_1_approved":
            case "step_1_redo_approved":
                return (
                    <div className="panel-adt">
                        <h2>Step 2 - Extended Information</h2>
                        <div className="adt-flex-container" style={{alignItems: "flex-start"}}>
                            <div className="adt-flex-icon">
                                <FontAwesomeIcon className="text-primary" size="lg" icon={faInfoCircle} fixedWidth />
                            </div>
                            <div className="adt-flex-item">
                                <p style={{margin:0}}>Please give a detailed response to each question.</p>
                            </div>
                        </div>
                    </div>
                );
            case "step_1_redo":
                return (
                    <div className="panel-adt">
                        <h2>Re-do Step 1 - Basic Information</h2>
                        <div className="adt-flex-container" style={{alignItems: "flex-start"}}>
                            <div className="adt-flex-icon">
                                <FontAwesomeIcon className="text-primary" size="lg" icon={faInfoCircle} fixedWidth />
                            </div>
                            <div className="adt-flex-item">
                                <p>A Recruitment Officer has requested that you re-do your basic information answers.</p>
                                {props.application.history.filter(history => history.state === "step_1_submitted" && history.action === "requested redo of").map((history, i) => (
                                    <div key={i}>
                                        <div className="pull-left">
                                            <Avatar image={props.users[history.user].avatar} rank={props.ranks[props.users[history.user].rank]} width="24" height="24"/>
                                        </div>
                                        <span style={{marginLeft: "3px",lineHeight:1.6}}><Username user={props.users[history.user]} rank={props.ranks[props.users[history.user].rank]} /></span>

                                        <p><FontAwesomeIcon className="text-primary" icon={faQuoteLeft} fixedWidth /> {history.reason.split('\n').map((reason, i) => (<span key={i}>{reason}<br /></span>))}
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                );
            case "step_2_redo":
                return (
                    <div className="panel-adt">
                        <h2>Re-do Step 2 - Extended Information</h2>
                        <div className="adt-flex-container" style={{alignItems: "flex-start"}}>
                            <div className="adt-flex-icon">
                                <FontAwesomeIcon className="text-primary" size="lg" icon={faInfoCircle} fixedWidth />
                            </div>
                            <div className="adt-flex-item">
                                <p>A Recruitment Officer has requested that you re-do your extended information answers.</p>
                                {props.application.history.filter(history => history.state === "step_2_submitted" && history.action === "requested redo of").map((history, i) => (
                                    <div key={i}>
                                        <div className="pull-left">
                                            <Avatar image={props.users[history.user].avatar} rank={props.ranks[props.users[history.user].rank]} width="24" height="24"/>
                                        </div>
                                        <span style={{marginLeft: "3px",lineHeight:1.6}}><Username user={props.users[history.user]} rank={props.ranks[props.users[history.user].rank]} /></span>

                                        <p><FontAwesomeIcon className="text-primary" icon={faQuoteLeft} fixedWidth /> {history.reason.split('\n').map((reason, i) => (<span key={i}>{reason}<br /></span>))}
                                        </p>
                                    </div>
                                ))}
                                <p style={{margin:0}}>Please provide as much detail as possible.</p>

                            </div>
                        </div>
                    </div>
                );
            case "step_3_interview":
                return (
                    <div className="panel-adt">
                        <h2>Step 3 - Interview</h2>
                        <div className="adt-flex-container" style={{alignItems: "flex-start"}}>
                            <div className="adt-flex-icon">
                                <FontAwesomeIcon className="text-primary" size="lg" icon={faInfoCircle} fixedWidth />
                            </div>
                            <div className="adt-flex-item">
                                <p style={{margin:0}}>Congratulations!  You have made it to the final step.  Please connect to our <a target="_blank" rel="noopener noreferrer" href="https://discord.gg/BEdRsJG"><FontAwesomeIcon className="text-primary" icon={faDiscord} fixedWidth /> Discord</a> server and arrange a time to undergo your interview with a recruitment officer.</p>
                            </div>
                        </div>
                    </div>
                );
            case "rejected":
                return (
                    <div className="panel-adt">
                        <h2>Application Rejected</h2>
                        <div className="adt-flex-container" style={{alignItems: "flex-start"}}>
                            <div className="adt-flex-icon">
                                <FontAwesomeIcon className="text-danger" size="lg" icon={faInfoCircle} fixedWidth />
                            </div>
                            <div className="adt-flex-item">
                                <p style={{margin:0}}>Your application has been reviewed and rejected.</p>
                            </div>
                        </div>
                    </div>
                );
            case "accepted":
                return (
                    <div className="panel-adt">
                        <h2>Application Accepted</h2>
                        <div className="adt-flex-container" style={{alignItems: "flex-start"}}>
                            <div className="adt-flex-icon">
                                <FontAwesomeIcon className="text-primary" size="lg" icon={faInfoCircle} fixedWidth />
                            </div>
                            <div className="adt-flex-item">
                                <p style={{margin:0}}>Your application has been reviewed and accepted.</p>
                            </div>
                        </div>
                    </div>
                );
            case "closed":
                return (
                    <div className="panel-adt">
                        <h2>Application Closed</h2>
                        <div className="adt-flex-container" style={{alignItems: "flex-start"}}>
                            <div className="adt-flex-icon">
                                <FontAwesomeIcon size="lg" icon={faInfoCircle} fixedWidth />
                            </div>
                            <div className="adt-flex-item">
                                <p style={{margin:0}}>Your application has been closed.</p>
                            </div>
                        </div>
                    </div>
                );
            default:
                return null
        }
    } else {
        return (
            <div className="panel-adt">
                <h2>Step One - Basic Information</h2>
                <div className="adt-flex-container" style={{alignItems: "flex-start"}}>
                    <div className="adt-flex-icon">
                        <FontAwesomeIcon className="text-primary" size="lg" icon={faInfoCircle} fixedWidth />
                    </div>
                    <div className="adt-flex-item">
                        <p style={{margin:0}}>Addiction does not disclose information about members or applicants.  Information submitted here is for our records only and is used to ensure the quality of our applicants.  Please fill out the required information as accurately and concisely as possible.  Officers reviewing applications will gauge their value based on experience as well as effort.</p>
                    </div>
                </div>
            </div>
        )
    }
};

export default StepInfo;


// WEBPACK FOOTER //
// ./src/Applications/StepInfo.js